import { postRequest } from "api";
import { auth } from "./endpoints";
import mem from "mem";

const refreshTokenFn = async () => {
  const data = JSON.parse(localStorage.getItem("data"));

  const getIp = async () => {
    const response = await fetch("https://ipapi.co/json/");
    const data = await response.json();
    return data.ip;
  };

  try {
    const ip = getIp();
    const payload = {
      IpAddress: ip,
    };

    const res = await postRequest(auth.refreshToken, payload, {
      headers: {
        Authorization: `Bearer ${data.RefreshToken}`,
        company: "oneclick",
      },
    });

    if (!res?.data.Jwt) {
      removeUserData();
    }

    let oldData = JSON.parse(localStorage.getItem("data"));

    oldData["Jwt"] = res.data?.Jwt;

    localStorage.setItem("data", JSON.stringify(oldData));

    //? Refresh the page
    window.location.reload();

    return res;
  } catch (error) {
    removeUserData();
  }
};

const maxAge = 10000;

export const memoizedRefreshToken = mem(refreshTokenFn, {
  maxAge,
});

export const removeUserData = () => {
  localStorage.removeItem("data");
  // localStorage.removeItem("menu");
  window.location.replace(auth.login);
};
